import styled from 'styled-components';

export const Container = styled.div`
  .no-option {
    text-align: center;
    margin: 1rem;
    font-size: 1.5rem;
    color: ${(p) => p.theme.colors.textLight};
  }

  .option-sortable-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export default Container;
